﻿(function () {
  var ITEMS_KEY = 'bn_wishlist';
  var DATA_KEY  = 'bn_wishlist_data';
  var toastEl   = null;
  var toastTimer = null;

  function loadItems() {
    try { return JSON.parse(localStorage.getItem(ITEMS_KEY)) || []; } catch (e) { return []; }
  }

  function saveItems(items) {
    localStorage.setItem(ITEMS_KEY, JSON.stringify(items));
  }

  function loadData() {
    try { return JSON.parse(localStorage.getItem(DATA_KEY)) || {}; } catch (e) { return {}; }
  }

  function saveData(data) {
    localStorage.setItem(DATA_KEY, JSON.stringify(data));
  }

  function hasItem(items, id) {
    return items.indexOf(String(id)) !== -1;
  }

  function toggleItem(productId, productData) {
    var items = loadItems();
    var data  = loadData();
    var sid   = String(productId);
    var added;
    var next;
    if (hasItem(items, sid)) {
      next  = items.filter(function (i) { return i !== sid; });
      added = false;
      delete data[sid];
    } else {
      next  = items.concat([sid]);
      added = true;
      if (productData) data[sid] = productData;
    }
    saveItems(next);
    saveData(data);
    return { items: next, added: added };
  }

  function updateButtons(items, productId) {
    var sel = productId
      ? '.wishlist-btn[data-product-id="' + productId + '"], .wishlist-pdp-btn[data-product-id="' + productId + '"]'
      : '.wishlist-btn[data-product-id], .wishlist-pdp-btn[data-product-id]';
    document.querySelectorAll(sel).forEach(function (btn) {
      var id     = btn.dataset.productId;
      var active = hasItem(items, id);
      btn.classList.toggle('wishlist-btn--active', active);
      btn.classList.toggle('wishlist-pdp-btn--active', active);
      btn.setAttribute('aria-label', active ? 'Remove from wishlist' : 'Add to wishlist');
    });
  }

  function updateCount(items) {
    var count = items.length;
    document.querySelectorAll('.wishlist-count').forEach(function (el) {
      el.textContent = count;
      el.classList.toggle('wishlist-count--hidden', count === 0);
    });
  }

  function getToast() {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'wishlist-toast';
      toastEl.innerHTML =
        '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
          '<path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>' +
        '</svg>' +
        '<span class="wishlist-toast__text"></span>';
      document.body.appendChild(toastEl);
    }
    return toastEl;
  }

  function showToast(added, title) {
    var toast = getToast();
    var msg   = added
      ? (title ? 'Added to Wishlist' : 'Added to Wishlist')
      : 'Removed from Wishlist';

    toast.querySelector('.wishlist-toast__text').textContent = msg;
    toast.classList.toggle('wishlist-toast--added', added);
    toast.classList.toggle('wishlist-toast--removed', !added);

    clearTimeout(toastTimer);
    toast.classList.remove('wishlist-toast--show');

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        toast.classList.add('wishlist-toast--show');
        toastTimer = setTimeout(function () {
          toast.classList.remove('wishlist-toast--show');
        }, 2800);
      });
    });
  }

  function refresh() {
    var items = loadItems();
    updateButtons(items);
    updateCount(items);
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.wishlist-btn, .wishlist-pdp-btn');
    if (!btn || !btn.dataset.productId) return;
    e.preventDefault();
    e.stopPropagation();
    var pData = {
      id:               btn.dataset.productId,
      handle:           btn.dataset.productHandle  || '',
      title:            btn.dataset.productTitle   || '',
      price:            btn.dataset.productPrice   || '',
      compare_at_price: btn.dataset.productCompare || '',
      url:              btn.dataset.productUrl     || '',
      image:            btn.dataset.productImage   || '',
      vendor:           btn.dataset.productVendor  || '',
      variants: (function() {
        var raw = btn.dataset.productVariants || '[]';
        var decoded = raw.replace(/&quot;/g, '"').replace(/&#39;/g, "'").replace(/&amp;/g, '&');
        try { var p = JSON.parse(decoded); return Array.isArray(p) ? p : []; }
        catch(e) { console.warn('[Wishlist] variant parse error:', e); return []; }
      })()
    };
    var result = toggleItem(btn.dataset.productId, pData);
    updateButtons(result.items, btn.dataset.productId);
    updateCount(result.items);
    showToast(result.added, pData.title);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refresh);
  } else {
    refresh();
  }

  window.addEventListener('storage', function (e) {
    if (e.key === ITEMS_KEY || e.key === DATA_KEY) refresh();
  });

  window.BnWishlist = { loadItems: loadItems, loadData: loadData };
})();
